import { AnalyticsEventType } from "@/constants/analytics";
import * as amplitude from "@/utils/amplitude";
import env from "@/env";
import { SESSION_UTM_KEY } from "@/utils/amplitude";
import localCookies from "./cookie";

export const trackEvent = (eventName: AnalyticsEventType, options?: Record<string, unknown>) => {
  console.log(eventName, options);
  amplitude.trackAmplitudeEvent(eventName, options);
};

export const getFirstTouchAttributions = () => {
  const storedSessionUtms = localCookies.getItem(SESSION_UTM_KEY);
  const sessionParams = storedSessionUtms ? JSON.parse(storedSessionUtms) : {};
  return {
    utm_source: sessionParams.utm_source || null,
    utm_medium: sessionParams.utm_medium || null,
    utm_campaign: sessionParams.utm_campaign || null,
    utm_term: sessionParams.utm_term || null,
    utm_content: sessionParams.utm_content || null,
    gclid: sessionParams.gclid || null,
    gbraid: sessionParams.gbraid || null,
    wbraid: sessionParams.wbraid || null,
    li_fat_id: sessionParams.li_fat_id || null,
    fbclid: sessionParams.fbclid || null,
    twclid: sessionParams.twclid || null
  };
};

export const getFBCLID = () => {
  let fbclid = null;
  fbclid = localCookies.getItem("_fbc") || localCookies.getItem("_fbp");
  return fbclid;
};
export const getFBPID = () => {
  let fbpid = null;
  fbpid = localCookies.getItem("_fbp");
  return fbpid;
};

export const getLinkedInFatId = () => {
  let li_fat_id = null;
  li_fat_id = localCookies.getItem("li_fat_id") || localCookies.getItem("_li_fat_id");
  return li_fat_id;
};

export const getGoogleAnalyticsHeaders = () => {
  const attribution = getFirstTouchAttributions();
  const fbclid = getFBCLID() || attribution.fbclid;
  const li_fat_id = getLinkedInFatId() || attribution.li_fat_id;
  const fbpid = getFBPID();
  const ga4Data = getGA4Data();
  return {
    ...(attribution.utm_source ? { "X-Utm-Source": attribution.utm_source } : {}),
    ...(attribution.utm_medium ? { "X-Utm-Medium": attribution.utm_medium } : {}),
    ...(attribution.utm_campaign ? { "X-Utm-Campaign": attribution.utm_campaign } : {}),
    ...(attribution.utm_term ? { "X-Utm-Term": attribution.utm_term } : {}),
    ...(attribution.utm_content ? { "X-Utm-Content": attribution.utm_content } : {}),
    ...(attribution.gclid ? { "X-Gclid": attribution.gclid } : {}),
    ...(attribution.gbraid ? { "X-Gbraid": attribution.gbraid } : {}),
    ...(attribution.wbraid ? { "X-Wbraid": attribution.wbraid } : {}),
    ...(fbclid ? { "X-Fbclid": fbclid } : {}),
    ...(li_fat_id ? { "X-Li-Fat-Id": li_fat_id } : {}),
    ...(attribution.twclid ? { "X-Twclid": attribution.twclid } : {}),
    ...(fbpid ? { "X-Fbpid": fbpid } : {}),
    ...(ga4Data.client_id ? { "X-Ga-Client-Id": ga4Data.client_id } : {}),
    ...(ga4Data.session_id ? { "X-Ga-Session-Id": ga4Data.session_id } : {})
  };
};

export function getGA4Data() {
  const measurementId = env.GA_MEASUREMENT_ID;
  // 1. Get Client ID (Standard _ga cookie)
  const gaCookie = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)");
  let clientId = null;
  if (gaCookie) {
    // GA1.1.123.456 -> 123.456
    clientId = decodeURIComponent(gaCookie[1]).substring(6);
  }

  // 2. Get Session ID (Dynamic _ga_<id> cookie)
  const idPattern = measurementId.replace("G-", "");
  const sessionCookieRegex = new RegExp("(?:^|;)\\s*_ga_" + idPattern + "=([^;]*)");
  const sessionCookie = document.cookie.match(sessionCookieRegex);

  let sessionId = null;
  if (sessionCookie) {
    const cookieValue = decodeURIComponent(sessionCookie[1]);

    // CHECK 1: New Compressed Format (contains "s" followed by numbers)
    // Example: s1764227138$o10... -> extracts 1764227138
    const compressedMatch = cookieValue.match(/s(\d{9,10})/);

    if (compressedMatch) {
      sessionId = compressedMatch[1];
    }
    // CHECK 2: Standard Format (GS1.1.SessionID.SessionStart...)
    // Example: GS1.1.1693456789.1.1... -> extracts 1693456789 (3rd part)
    else {
      const parts = cookieValue.split(".");
      if (parts.length > 2) {
        sessionId = parts[2];
      }
    }
  }

  return {
    client_id: clientId,
    session_id: sessionId
  };
}
